import {
  KenticoPageDefinition,
  KenticoFormViewmodel,
  BaseRelatedViewModel,
  MenuItem,
  IHasHeaderImage
} from '../interfaces/PageInterfaces';

import { UserService } from '@fnv-core/authentication';
import { ACCOUNT_AANMAKEN_URL } from '../../../constants/Constants';

export const widgetClassNames = {
  formClass: 'FNV.ContentBlock',
  alertClass: 'Alert.Class',
  linkBlockClass : 'FNV.HandigeLinksBlock',
  contentBlockClass : 'FNV.MijnFnvRichTextBlock',
  paymentBlockClass : 'FNV.MijnFnvContributieBetalenBlock',
  idealBankKeuzeBlockClass : 'FNV.iDealBetaalSchermBlock',
  tipBlockClass : 'FNV.MijnFnvTipBlock',
  digitaleLedenPasBlockClass : 'FNV.MijnFnvDigitaleLedenPasBlock',
  lidZoekenBlockClass : 'FNV.MijnFnvLidZoekenBlock',
  downloadBlockClass: 'FNV.DownloadsBlock',
  mijnFnvLinkBlockClass: 'FNV.MijnFnvLinkBlock',
  profielFotoBlockClass: 'FNV.MijnFnvProfielFotoBlock',
  mijnFnvViewPageBlockClass: 'FNV.MijnFnvViewPagina',
  consentBlockClass: 'FNV.MijnFNVConsentDetail',
};

export class PageHelpers {

  static getForms(pageDefinition: KenticoPageDefinition): KenticoFormViewmodel[] {
    return (pageDefinition.RelatedViewModels || []).filter(
      item => item.MijnFnvContentBlockModel !== undefined && 
          item.MijnFnvContentBlockModel.ClassName === widgetClassNames.formClass
    ).map(item => item.MijnFnvContentBlockModel) as KenticoFormViewmodel[];
  }

  static getWidgets(pageDefinition: KenticoPageDefinition): BaseRelatedViewModel[] {
    return (pageDefinition.RelatedViewModels || []).filter(
      item => {
        return (item.MijnFnvContentBlockModel && 
            item.MijnFnvContentBlockModel.ClassName &&
          item.MijnFnvContentBlockModel.ClassName !== widgetClassNames.alertClass) ||
          (item.MijnFnvHandigeLinksBlockModel &&
            item.MijnFnvHandigeLinksBlockModel.ClassName) ||
          (item.MijnFnvRichTextBlockModel &&
            item.MijnFnvRichTextBlockModel.ClassName) ||
          (item.MijnFnvProfielFotoBlockModel &&
            item.MijnFnvProfielFotoBlockModel.ClassName) ||
          (item.MijnFnvPaymentBlockModel &&
            item.MijnFnvPaymentBlockModel.ClassName) ||
          (item.MijnFnvLinkBlockModel &&
            item.MijnFnvLinkBlockModel.ClassName) ||
          (item.MijnFnvTipBlockModel &&
           item.MijnFnvTipBlockModel.ClassName) ||
          (item.MijnFnvDigitaleLedenPasBlockModel &&
            item.MijnFnvDigitaleLedenPasBlockModel.ClassName) ||
          (item.MijnFnvIdealBankSelectorBlockModel &&
            item.MijnFnvIdealBankSelectorBlockModel.ClassName) ||
          (item.MijnFnvLidZoekenBlockModel &&
            item.MijnFnvLidZoekenBlockModel.ClassName) ||
          (item.MijnFnvViewPagina &&
            item.MijnFnvViewPagina.ClassName) ||
          (item.ConsentDetailModel && item.ConsentDetailModel.ClassName)
           ;
      }
    ).map(item => {    
      return item.MijnFnvContentBlockModel || 
          item.MijnFnvHandigeLinksBlockModel ||
          item.MijnFnvRichTextBlockModel ||
          item.MijnFnvPaymentBlockModel ||
          item.MijnFnvProfielFotoBlockModel ||
          item.MijnFnvTipBlockModel ||
          item.MijnFnvLinkBlockModel ||
          item.MijnFnvLidZoekenBlockModel ||
          item.MijnFnvDigitaleLedenPasBlockModel ||
          item.MijnFnvIdealBankSelectorBlockModel ||
          item.MijnFnvViewPagina ||
          item.ConsentDetailModel
        ;
      });
  };

  static getSideMenu(pageDefinition: KenticoPageDefinition) {
    // Alert box is also a widget, but we dont want to show that
    return (pageDefinition.Menu || []) as MenuItem[];
  };

  static getHeaderImage(pageDefinition: KenticoPageDefinition): string | null {
    const pageWithHeaderImage = pageDefinition.MijnFnvViewPagina 
    || pageDefinition.MijnFnvEditPagina
    || pageDefinition.MijnFnvCTAViewPagina
      // Overzicht als laatste, omdat deze blijkbaar weleens met rare data gevuld is
    || pageDefinition.MijnFnvOverzicht;
    if (!pageWithHeaderImage) {
      return null;
    }

    return (pageWithHeaderImage as IHasHeaderImage).HeaderFoto;
  };

  static showSteps(pageDefinition: KenticoPageDefinition) {
    // Show steps on Edit Pages, but not when explicitly hidden
    return pageDefinition.MijnFnvEditPagina && !pageDefinition.MijnFnvEditPagina.HideSteps;
  };

  static splitWidgetsToColumns(list: any[]): { label: string; list: any[] }[] {
    // listOne has more items if number of items is an odd number
    const listOne = list.slice(0, Math.ceil(list.length / 2));
    // listTwo gets the remaning items after slice
    const listTwo = list.slice(Math.ceil(list.length / 2));

    // Make render list for simple parsing
    return [{ label: '', list: listOne }, { label: '', list: listTwo }];
  };

  static getFrontendPageTypeFromKenticoPageType(kenticoPageType : string) : string {
    const pageTypeMap = {
      "FNV.MijnFnvOverzicht" : "dashboard",
      "FNV.Profiel" : "view",
      "FNV.ContentBlock" : "view",
      "digitaleledenpas" : "digitaleledenpas",
      "view" : "view",
      "edit" : "edit",
      "FNV.Content" : "edit",
      "FNV.MijnFnvViewPagina": "view",
      "FNV.MijnFnvCTAViewPagina": "ctaview",
      "FNV.MijnFnvEditPagina": "edit",
      "FNV.MijnFnvLoginAlsPagina": "edit",
      "FNV.MijnFnvWebshopOverviewPagina" : "webshop",
      "FNV.MijnFnvWebshopProductDetailPagina" : "webshopProduct",
      "FNV.MijnFnvWebshopShoppingCartPagina" : "webshopShoppingCart"
    };
    return pageTypeMap[kenticoPageType] || "";
  };

  static setBreadcrumbsPageTitle(pageTitle: string) {
    const breadcrumbForEditPage = document.querySelector('.mijn-fnv__breadcrumb-for-edit-page');
    if (breadcrumbForEditPage) {
      breadcrumbForEditPage.textContent = pageTitle;
    }
  };

  static highlightMainNavigationItem() {    
    PageHelpers.unhighlightAllMainNavigationItems();

    const activeItem = document.querySelector(
      ".nav-link.main-navbar__nav-link[href='" + location.pathname + "']"
    );
    if (activeItem) {
      activeItem.parentElement.classList.add('active');
    }
    
    const backToMijnFnvLink = document.querySelector('.link__back-to-mijnfnv');
    if (backToMijnFnvLink) {
      backToMijnFnvLink.addEventListener('click', () => {
          PageHelpers.unhighlightAllMainNavigationItems();
      });
    }
  };

  private static unhighlightAllMainNavigationItems() {
    const allItems = document.querySelectorAll(".nav-link.main-navbar__nav-link");
    allItems.forEach(function (item) {
      item.parentElement.classList.remove('active');
    });
  };

  static getMijnFNVRootPathForRole = (backLink: string) => {
    if (backLink === "" || backLink === "/") {
      return UserService.getCurrentRolePath();
    }
    return backLink;
  };

  static isNotCreateAccountPage = (currentPathname) => {
    return currentPathname.toLowerCase() != ACCOUNT_AANMAKEN_URL.toLowerCase();
  };
}